export const LOGIN_PATH = 'login';
export const FORGET_PASSWORD_PATH = 'forget-password';
export const RESET_PASSWORD_PATH = 'reset-password';

export const REGISTRATION_PATH = 'e5e6edd233a84dd09f5de7a2d8b884ca';
export const ALTERNATIVE_REGISTRATION_PATH = 'register';
export const CYBERSECURITY_COCKPIT_PATH = 'cybersecurity-cockpit';
export const PARTNER_COCKPIT_PATH = 'partner-cockpit';
export const ADMIN_COCKPIT_PATH = 'admin-cockpit';
export const DASHBOARD_PATH = 'dashboard';
export const MODULE_CONFIGURATIONS_PATH = 'module-configurations';
export const TEST_RUNS_PATH = 'test-runs';
export const PROFILE_PATH = 'profile';
export const SETTINGS_PATH = 'settings';
export const BOXES_PATH = 'boxes';
export const USERS_PATH = 'users';
export const CUSTOMERS_PATH = 'customers';
export const PARTNERS_PATH = 'partners';
export const PARTNERS_RESOURCES_PATH = 'resources';
export const INITIAL_SCAN_PATH = 'initial-scan';
export const PENTEST_CALENDAR_PATH = 'pentest-calendar';
export const NOT_FOUND_PATH = '404';
